export default "__VITE_ASSET__Cs$AztUH__"